import React, { useState, useEffect } from "react";
import Sidebar from '../../../composant_reutilisable/sidebar';
import Navbar from "../../../composant_reutilisable/navbar";
import useAuth from '../../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import TableauDynamique from "../../../composant_reutilisable/tableau";
import { BsPeople, BsCarFront } from "react-icons/bs";
import { Modal, Button, Form } from "react-bootstrap"; // Ajout du modal Bootstrap
import ModalComponent from "../../../composant_reutilisable/composant_modal";
import { FaChevronDown, FaChevronUp, FaEdit, FaPlus, FaQuestionCircle, FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';
import GlossaireSidebar from '../../../composant_reutilisable/glossaireSidebar';
import Pas_acces from "../../../composant_reutilisable/pas_acces";
import axios from "axios";

const ListeTypesVehicules = () => {
    useAuth();
    const navigate = useNavigate();

    // const utilisateur_id = localStorage.getItem("utilisateur_id");
    const [isLoading, setIsLoading] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [types, setTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //const [typeSelectionne, setTypeSelectionne] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);

    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Type vehicule";
        }
    }, [user_id]);

    // États pour gérer le modal
    const [showModal, setShowModal] = useState(false);
    const [nouveauType, setNouveauType] = useState({ libelle: "", description: "", option: "", genre: "" });

    const [typeSelectionne, setTypeSelectionne] = useState({
        libelle: '',
        description: '',
        genre: '',
        ref: '',
        option: '',
    });


    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 5000);
    };

    // Récupération des types
    const fetchTypes = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-types/");
            if (response.ok) {
                const data = await response.json();
                setTypes(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des types:", error);
        }
    };

    const handleRecupListeSygfr = async () => {
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/api/type-vehicule/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
        } catch (error) {
            console.error('Erreur lors de l\'harmonisation:', error);
            showAlert('Erreur réseau lors de l\'harmonisation', 'danger');
            return { success: false, error: 'Erreur réseau' };
        }
    };



    useEffect(() => {
        fetchTypes();
        handleRecupListeSygfr();
    }, []);

    const colonnesTypes = [
        //{ libelle: "Id", cle: "id" },
        { titre: "Référence", cle: "ref" },
        { titre: "Libelle", cle: "libelle" },
        // { titre: "Description", cle: "description" },
        { titre: "Option", cle: "option" },
        { titre: "Genre", cle: "genre" },
    ];

    // Filtrage
    const typesFiltres = types.filter(type =>
        type?.libelle?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        type?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        type?.option?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        type?.ref?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        type?.genre?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Pagination
    const totalItems = typesFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const typesAffiches = typesFiltres.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionType = (type) => {
        setTypeSelectionne(type);
    };

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        const { name, value } = e.target;
        // Si le genre change, on réinitialise aussi l'option
        setNouveauType((prev) => {
            const updated = {
                ...prev,
                [name]: name === 'libelle' ? value.toUpperCase() : value,
            };

            if (name === "genre") {
                updated.option = ""; // reset option si genre change
            }

            return updated;
        });
    };

    // const handleAjouterType = async () => {
    //     const erreurs = [];

    //     if (!nouveauType.libelle.trim()) {
    //         erreurs.push("Le libellé est obligatoire.");
    //     }

    //     if (!nouveauType.genre) {
    //         erreurs.push("Le genre est obligatoire.");
    //     }

    //     if (nouveauType.genre === "articule" && !nouveauType.option) {
    //         erreurs.push("L'option est obligatoire pour un genre articulé.");
    //     }

    //     if (erreurs.length > 0) {
    //         showAlertModal(erreurs.join(" "), "danger");
    //         return;
    //     }

    //     try {
    //         const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-type/${user_id}/`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(nouveauType),
    //         });

    //         if (response.ok) {
    //             // fetchTypes()
    //             setNouveauType({ libelle: "", description: "", option: "", });
    //             handleCloseModal();
    //             showAlertModal("Type ajouté avec succès", "success");
    //         } else {
    //             showAlertModal("Erreur lors de l'ajout du type.", "danger");
    //         }
    //     } catch (error) {
    //         console.error("Erreur réseau:", error);
    //         showAlertModal("Une erreur est survenue. Veuillez réessayer.", "danger");
    //     }
    // };


    const handleShowDeleteModal = () => {
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };


    // const handleDeleteType = async () => {
    //     if (typeSelectionne) {
    //         try {
    //             const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-type/${typeSelectionne.id}/${user_id}/`, {
    //                 method: 'DELETE',
    //             });

    //             if (response.ok) {
    //                 setTypes(types.filter((type) => type.id !== typeSelectionne.id));
    //                 setTypeSelectionne(null);

    //                 // Stocker le message de succès dans localStorage
    //                 showAlert('Type supprimé avec succès !');
    //             } else {
    //                 console.error('Erreur lors de la suppression du type');
    //             }
    //         } catch (error) {
    //             console.error('Erreur réseau:', error);
    //         } finally {
    //             setShowDeleteModal(false);
    //         }
    //     }
    // };



    const handleShowModifierModal = () => {
        setShowModifierModal(true);
    };

    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
    };

    // const handleModifierType = async () => {

    //     if (typeSelectionne) {
    //         const erreurs = [];

    //         if (!typeSelectionne.libelle.trim()) {
    //             erreurs.push("Le libellé est obligatoire.");
    //         }

    //         if (!typeSelectionne.genre) {
    //             erreurs.push("Le genre est obligatoire.");
    //         }

    //         if (typeSelectionne.genre === "articule" && !typeSelectionne.option) {
    //             erreurs.push("L'option est obligatoire pour un genre articulé.");
    //         }

    //         if (erreurs.length > 0) {
    //             showAlertModal(erreurs.join(" "), "danger");
    //             return;
    //         }
    //         try {
    //             const response = await fetch(
    //                 `${process.env.REACT_APP_HOTE}/modifier-type/${typeSelectionne.id}/${user_id}/`,
    //                 {
    //                     method: 'PUT', // ou PATCH si tu veux modifier partiellement
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                     },
    //                     body: JSON.stringify({
    //                         libelle: typeSelectionne.libelle,
    //                         description: typeSelectionne.description, // Assure-toi d'envoyer les bonnes données
    //                         option: typeSelectionne.option,
    //                         genre: typeSelectionne.genre,
    //                     }),
    //                 }
    //             );

    //             if (response.ok) {
    //                 const updatedType = await response.json();

    //                 // Mettre à jour la liste des types avec la modification
    //                 setTypes(types.map((type) =>
    //                     type.id === typeSelectionne.id ? updatedType : type
    //                 ));

    //                 showAlert('Type modifié avec succès !');
    //             } else {
    //                 console.error('Erreur lors de la modification du type');
    //             }
    //         } catch (error) {
    //             console.error('Erreur réseau:', error);
    //         } finally {
    //             setShowModifierModal(false);
    //         }
    //     }
    // };

    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token');
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Elementaires")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <BsCarFront size={25} className='mr-2' />Types de véhicules
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-elementaires'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des types de véhicules.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Elementaires`}> Elémentaires</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Types de véhicules
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des types</h5>
                            {/* <div className="text-right">
                                <button className="btn btn-success mr-2" onClick={handleOpenModal}>
                                    <FaPlus />Ajouter
                                </button>
                                <button
                                    onClick={() => handleShowModifierModal(typeSelectionne)}
                                    className={`btn mb-2 mb-md-0 ms-0 ms-md-2 mr-2 ${typeSelectionne ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!typeSelectionne}
                                >
                                    <FaEdit /> Modifier
                                </button>
                                <button
                                    onClick={() => handleShowDeleteModal(typeSelectionne)}
                                    className={`btn mb-2 mb-md-0 ms-0 ms-md-2 ${typeSelectionne ? 'btn-success' : 'btn-default text-dark'}`}
                                    disabled={!typeSelectionne}
                                >
                                    <FaTrash /> Supprimer
                                </button>
                            </div> */}
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <TableauDynamique
                                            colonnes={colonnesTypes}
                                            donnees={typesFiltres}
                                            isLoading={isLoading}
                                            messageAucun="Aucun type de véhicules trouvé."
                                            onSelectRow={handleSelectionType}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal d'enregistrement */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Créer un type</Modal.Title>
                </Modal.Header>
                {alertModal.message && (
                    <div className={`m-2 alert alert-${alertModal.type}`}>
                        {alertModal.message}
                    </div>
                )}
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formType">
                            {/* Libellé */}
                            <Form.Label>Nom du type</Form.Label>
                            <Form.Control
                                type="text"
                                name="libelle"
                                value={nouveauType?.libelle || ''}
                                onChange={handleChange}
                            />

                            {/* Description */}
                            <Form.Label>Description du type</Form.Label>
                            <Form.Control
                                type="text"
                                name="description"
                                value={nouveauType?.description || ''}
                                onChange={handleChange}
                            />

                            {/* Genre (radio) */}
                            <Form.Label>Genre</Form.Label>
                            <div key="inline-radio-genre" className="mb-3">
                                <Form.Check
                                    inline
                                    label="Articulé"
                                    name="genre"
                                    type="radio"
                                    id="genre-articule"
                                    value="articule"
                                    checked={nouveauType.genre === "articule"}
                                    onChange={handleChange}
                                />
                                <Form.Check
                                    inline
                                    label="Non Articulé"
                                    name="genre"
                                    type="radio"
                                    id="genre-non-articule"
                                    value="non_articule"
                                    checked={nouveauType.genre === "non_articule"}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Option visible seulement si genre = articule */}
                            {nouveauType?.genre === "articule" && (
                                <>
                                    <Form.Label>Option</Form.Label>
                                    <div key="inline-radio-option" className="mb-3">
                                        <Form.Check
                                            inline
                                            label="Tête"
                                            name="option"
                                            type="radio"
                                            id="option-tete"
                                            value="Tete"
                                            checked={nouveauType?.option === "Tete"}
                                            onChange={handleChange}
                                        />
                                        <Form.Check
                                            inline
                                            label="Queue"
                                            name="option"
                                            type="radio"
                                            id="option-queue"
                                            value="Queue"
                                            checked={nouveauType?.option === "Queue"}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        <strong>Annuler</strong>
                    </Button>
                    {/* <Button variant="success" onClick={handleAjouterType}>
                        <strong>Ajouter</strong>
                    </Button> */}
                </Modal.Footer>
            </Modal>


            {/* <ModalComponent
                show={showModal}
                handleClose={handleCloseModal}
                title="Créer un type"
                fields={[
                    { name: "libelle", label: "Libelle", placeholder: "Libelle du type", required: true },
                    { name: "description", label: "Description", type: "textarea", placeholder: "Description du type", required: true },
                    { name: "genre", label: "Genre", type: "select", options: [ { value: "articule", label: "Articulé" }, { value: "non_articule", label: "Non Articulé" },], required: true },
                    { name: "option", label: "Option", type: "select", options: [ { value: "Tete", label: "Tête" }, { value: "Queue", label: "Queue" },], required: true },
                ]}
                formData={nouveauType}
                handleChange={handleChange}
                handleSubmit={handleAjouterType}
                submitText="Ajouter"
            /> */}

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer le type <strong>{typeSelectionne?.libelle}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Annuler</strong>

                    </Button>
                    {/* <Button variant="success" onClick={handleDeleteType}>
                        <strong>Supprimer</strong>

                    </Button> */}
                </Modal.Footer>
            </Modal>

            {/* Modal de modification */}
            <Modal show={showModifierModal} onHide={handleCloseModifierModal} >
                <Modal.Header>
                    <Modal.Title>Modifier le type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formType">
                            <Form.Label>Nom du type</Form.Label>
                            <Form.Control
                                type="text"
                                value={typeSelectionne?.libelle || ''}
                                onChange={(e) =>
                                    setTypeSelectionne({ ...typeSelectionne, libelle: e.target.value.toUpperCase() })
                                }
                            />
                            <Form.Label>Description du type</Form.Label>
                            <Form.Control
                                type="text"
                                value={typeSelectionne?.description || ''}
                                onChange={(e) =>
                                    setTypeSelectionne({ ...typeSelectionne, description: e.target.value })
                                }
                            />
                            <Form.Label>Genre</Form.Label>
                            <div key="inline-radio" className="mb-3">
                                <Form.Check
                                    inline
                                    label="Articulé"
                                    name="genre"
                                    type="radio"
                                    id="genre-articule"
                                    value="articule"
                                    checked={typeSelectionne?.genre === "articule"}
                                    onChange={(e) =>
                                        setTypeSelectionne({ ...typeSelectionne, genre: e.target.value, option: "" })
                                    }
                                />
                                <Form.Check
                                    inline
                                    label="Non Articulé"
                                    name="genre"
                                    type="radio"
                                    id="genre-non-articule"
                                    value="non_articule"
                                    checked={typeSelectionne?.genre === "non_articule"}
                                    onChange={(e) =>
                                        setTypeSelectionne({ ...typeSelectionne, genre: e.target.value, option: "" })
                                    }
                                />
                            </div>

                            {/* Affichage des options uniquement si genre = articulé */}
                            {typeSelectionne?.genre === "articule" && (
                                <>
                                    <Form.Label>Option</Form.Label>
                                    <div key="inline-radio-option" className="mb-3">
                                        <Form.Check
                                            inline
                                            label="Tête"
                                            name="option"
                                            type="radio"
                                            id="option-tete"
                                            value="Tete"
                                            checked={typeSelectionne?.option === "Tete"}
                                            onChange={(e) =>
                                                setTypeSelectionne({ ...typeSelectionne, option: e.target.value })
                                            }
                                        />
                                        <Form.Check
                                            inline
                                            label="Queue"
                                            name="option"
                                            type="radio"
                                            id="option-queue"
                                            value="Queue"
                                            checked={typeSelectionne.option === "Queue"}
                                            onChange={(e) =>
                                                setTypeSelectionne({ ...typeSelectionne, option: e.target.value })
                                            }
                                        />
                                    </div>
                                </>
                            )}

                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModifierModal}>
                        <strong>Annuler</strong>
                    </Button>
                    {/* <Button variant="success" onClick={handleModifierType}>
                        <strong>Modifier</strong>
                    </Button> */}
                </Modal.Footer>
            </Modal>

            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default ListeTypesVehicules;
